const ANIMATION_TYPE = {
    MOUSE_TRANSLATE: 0,
    ARROW_RIGHT: 1,
    LONG_RIGHT_ARROW: 2
};

export {
    ANIMATION_TYPE
}